import * as PersonApi from "../../api/personApi";
import * as UserApi from "../../api/users";
import * as UserOrderApi from "../../api/userOrderApi";
import {
  REQUEST_USER_ORDERS,
  REQUEST_ADMINS,
  UserActionTypes,
  REQUEST_USERS
} from "./types";
import { isOk } from "../../result";
import { Person } from "../../models/Person";
import { LifvsUser, UserOrder, UserOrderType } from "../../models/User";

const fetchAdmins = (payload: ReadonlyArray<Person>): UserActionTypes => ({
  type: REQUEST_ADMINS,
  payload
});

const fetchUserOrders = (
  payload: ReadonlyArray<UserOrder>
): UserActionTypes => ({
  type: REQUEST_USER_ORDERS,
  payload
});

const fetchUsers = (payload: ReadonlyArray<LifvsUser>): UserActionTypes => ({
  type: REQUEST_USERS,
  payload
});

export const thunkFetchAdmins = () => async (dispatch: any) => {
  const result = await PersonApi.list();

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchAdmins(result.value));
};

export const thunkFetchUsers = () => async (dispatch: any) => {
  const result = await UserApi.list();
  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchUsers(result.value));
};

export const thunkFetchUserOrders = () => async (dispatch: any) => {
  const result = await UserOrderApi.listActiveOrders(
    UserOrderType.ClickNCollect
  );

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchUserOrders(result.value));
};
